import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import * as mensagens from '../../common/Mensagens';
import {
  excluirIntegrantesPorObito
} from '../../api/familiaAPI';
import { ErrorCodeEnum } from '../../common/CodigosErro';

export interface ExclusaoPorObitoState {
  integrantesParaExclusao: any[],
  exibirMensagemErro: boolean,
  exibirMensagemSucesso: boolean,
  mensagem: string
}

const initialState: ExclusaoPorObitoState = {
  integrantesParaExclusao: [],
  exibirMensagemErro: false,
  exibirMensagemSucesso: false,
  mensagem: ''
};

export const exclusaoIntegrantesPorObito = createAsyncThunk('exclusaoPorObito/excluirIntegrantesPorObito',
  async (dados: any) => {
    return await excluirIntegrantesPorObito(dados);
  }
);

export const exclusaoPorObitoSlice = createSlice({
  name: 'exclusaoPorObito',
  initialState,
  reducers: {
    setIntegrantesParaExclusao: (state, action) => {
      state.integrantesParaExclusao = action.payload;
    },
    addIntegranteParaExclusao: (state, action) => {
      state.integrantesParaExclusao.push(action.payload);
    },
    limpar: (state) => {
      state.integrantesParaExclusao = initialState.integrantesParaExclusao;
      state.exibirMensagemErro = false;
      state.exibirMensagemSucesso = false;
    },
    hideMensagemErro: (state) => {
      state.exibirMensagemErro = false;
    },
    hideMensagemSucesso: (state) => {
      state.exibirMensagemSucesso = false;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(exclusaoIntegrantesPorObito.fulfilled, (state, action) => {
      if (action.payload.codigoErro === ErrorCodeEnum.EXCLUSAO_PESSOA_OBITO_FORA_HORARIO) {
        state.exibirMensagemSucesso = false;
        state.exibirMensagemErro = true;
        state.mensagem = mensagens.MSG_EXCLUSAO_PESSOA_OBITO_FORA_HORARIO;
      } else if (action.payload.codigoErro === ErrorCodeEnum.DT_ALTERACAO_EXCLUSAO_OBITO) {
        state.exibirMensagemSucesso = false;
        state.exibirMensagemErro = true;
        state.mensagem = mensagens.MSG_DATA_ALTERACAO_FAMILIA;
      } else {
        state.exibirMensagemSucesso = true;
        state.exibirMensagemErro = false;
        state.mensagem = '';
      }
    })
    .addCase(exclusaoIntegrantesPorObito.rejected, (state, error: any) => {
      if (error.error.message === mensagens.MSG_SISTEMA_CAIXA_INDISPONIVEL) {
        state.mensagem = mensagens.MSG_TENTE_NOVAMENTE;
      }

      if (error.error.message === mensagens.MSG_TENTE_NOVAMENTE) {
        state.mensagem = mensagens.MSG_TENTE_NOVAMENTE;
      }

      if (error.error.message.includes(mensagens.MSG_SERVICO_PORTAL_FORA_HORARIO)) {
        state.mensagem = error.error.message;
      }

      state.exibirMensagemErro = true;
      state.exibirMensagemSucesso = false;
    })
  }
});

export const { hideMensagemErro, hideMensagemSucesso } = exclusaoPorObitoSlice.actions;

export const selectIntegrantesParaExclusao = (state: RootState) =>
  state.exclusaoPorObito.integrantesParaExclusao;
export const exibirMensagemErro = (state: RootState) => state.exclusaoPorObito.exibirMensagemErro;
export const exibirMensagemSucesso = (state: RootState) => state.exclusaoPorObito.exibirMensagemSucesso;
export const exibirTextoMensagem = (state: RootState) => state.exclusaoPorObito.mensagem;

export default exclusaoPorObitoSlice.reducer;
